import React, { useState, useEffect } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { makeStyles, createStyles, withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import ApngComponent from 'react-apng';
import GuidApng from '../../assets/animations/general_funnel_guide.png';
import Tr from '../shared/tr';

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    width: 500,
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#F4AA20',
  },
}))(LinearProgress);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      backgroundColor: '#F5F5F5',
      width: '100%',
    },
  })
);

interface BusyDlgProps {
  open: boolean;
  title: string;
}

function BusyDlg(props: BusyDlgProps) {
  const classes = useStyles();
  const tr = new Tr();
  const title = props.title === 'Import Data' ? tr.busyDlgImportData() : props.title;
  return (
    <Dialog
      open={props.open}
      classes={{
        paper: classes.paper,
      }}
    >
      <DialogContent>
        <Grid container direction="column" justify="center" alignItems="center">
          <ApngComponent src={GuidApng} autoPlay={true} />
          <Typography variant="h5">
            <b>{title}</b>
          </Typography>
          <div style={{ height: 10 }} />
          <BorderLinearProgress />
          <div style={{ height: 10 }} />
          <Typography>{tr.busyDlgProcessing()}</Typography>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default BusyDlg;
